import { render, staticRenderFns } from "./OutboundView.vue?vue&type=template&id=dd14887e&"
import script from "./OutboundView.vue?vue&type=script&lang=js&"
export * from "./OutboundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports